<template>
  <div v-if="config">
    <custom-canvas
      v-if="configPoints"
      :config="configPoints"
      :locale="locale"
      :isDesktop="isDesktop"
    />
  </div>
</template>
<script>
import apiDtouch from '@/services/apiDtouch'
import utils from '@/services/utils'
import CustomCanvas from './CustomCanvas'
export default {
  name:'Item57InteractiveMaps',
  components: {
    CustomCanvas,
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
    config: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    mapConfig: null,
    configPoints: null,
    oldWidth: null,
  }),
  computed: {
    workspaceID () {
      return this.$store.state.app.dtouchWorkspace
      //return utils.getWorkspaceIdentification ()
    },
  },
  mounted () {
    this.handleGetData()
    const that = this
    window.addEventListener("resize", function() {
      const w = (document.getElementsByClassName('main-content-items')[0].clientWidth)
      if (w !== that.oldWidth) that.handleGetData()
    })
  },
  methods: {
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    handleChangeMap (v) {

    },
    async handleGetData () {
      this.configPoints = null
      try {
        if (!this.content.InteractiveMapsID) return
        const categories = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.content.InteractiveMapsID}/categories`)
          .then(response => {
            if (response && response.length > 0) {
              response = response.map(item => {
                item.Name = JSON.parse(item.Name)
                return item
              })
              response.unshift({
                ID: null,
                Icon: 'mdi-folder',
                Name: { es: 'TODOS', en: 'ALL'}
              })
            }
            resolve(response)
          }).catch (error => {
            reject(error)
          }))

        /*
        this.mapConfig = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.content.InteractiveMapsID}/map-config`)
          .then(response => {
            resolve(response)
          }).catch (error => {
            reject(error)
          }))

        console.log('jhm', this.mapConfig.map(item => {
          return {
            Name: item.Name,
            ParentID: item.ParentID,
            ORD: item.ORD
          }
        }))*/
        const map = await new Promise((resolve, reject) => apiDtouch.getItem(`v2/public/interactive-maps/${this.content.InteractiveMapsID}`)
          .then(response => {
            resolve(response)
          }).catch (error => {
            reject(error)
          }))
        const points = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.content.InteractiveMapsID}/points`)
          .then(response => {
            resolve(response.map(item => {
              item.Title = JSON.parse(item.Title)
              item.Description = JSON.parse(item.Description)
              item.Info = item.Info ? JSON.parse(item.Info) : null
              return item
            }))
          }).catch (error => {
            reject(error)
          }))
        const w = (document.getElementsByClassName('main-content-items')[0].clientWidth)
        this.oldWidth = w
        //const scale = w > v.Width ? 1 : w / v.Width
        const scale =  w / map.Width
        const width = map.Width * scale | 0
        const height = map.Height * scale | 0

        this.configPoints = {
          background: map.Image,
          scale,
          width,
          height,
          points,
          categories,
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
<style scoped>
  .requests-result {
    table-layout: fixed;
    width: 100% !important;
    max-width: 100% !important;
  }
  .requests-result .name {
    width: auto;
    line-height: 1;
  }
  .requests-result .action {
    width: 100px;
    /*white-space: nowrap;*/
    text-align: right;
    vertical-align: top;
  }
</style>


